// Format the calendar day embedded in a period ISO string (ignores time/offset),
// so "2026-10-12T00:00:00+00:00" and "2026-10-25T23:59:59-05:00" read Oct 12 / Oct 25.
export const formatPeriodDay = (iso, opts = {}) => {
  if (!iso) return "";
  const [y, m, d] = String(iso).slice(0, 10).split("-").map(Number);
  if (!y || !m || !d) return "";
  return new Date(y, m - 1, d).toLocaleDateString("en-US", { month: "short", day: "numeric", ...opts });
};

export const shiftPeriodDay = (iso, days) => {
  const [y, m, d] = String(iso).slice(0, 10).split("-").map(Number);
  const dt = new Date(y, m - 1, d + days);
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`;
};
